export interface ICsvColumn {
  id: string;
  header: string;
  type: IColumnPreferenceType;
  isPreference: boolean;
}

const escapeCSVValue = (value: string): string => {
  const str = String(value ?? '');
  if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
};

export const generateCSVContent = (
  columns: ICsvColumn[],
  rows: Record<string, string>[]
): string => {
  const header = columns.map((col) => escapeCSVValue(col.header)).join(',');
  const body = rows
    .map((row) => columns.map((col) => escapeCSVValue(row[col.id] ?? '')).join(','))
    .join('\n');
  return `${header}\n${body}`;
};

export const downloadCSV = (content: string, filename: string): void => {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
